import React from "react";
import PropTypes from "prop-types";

const Icon = ({ pathFill, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 25"
      {...rest}
    >
      <path
        d="M8 5.50005C7.01165 5.50082 6.49359 5.51338 6.09202 5.71799C5.71569 5.90973 5.40973 6.21569 5.21799 6.59202C5 7.01984 5 7.57989 5 8.7V18.3C5 19.4201 5 19.9802 5.21799 20.408C5.40973 20.7843 5.71569 21.0903 6.09202 21.282C6.51984 21.5 7.07989 21.5 8.2 21.5H15.8C16.9201 21.5 17.4802 21.5 17.908 21.282C18.2843 21.0903 18.5903 20.7843 18.782 20.408C19 19.9802 19 19.4201 19 18.3V8.7C19 7.57989 19 7.01984 18.782 6.59202C18.5903 6.21569 18.2843 5.90973 17.908 5.71799C17.5064 5.51338 16.9884 5.50082 16 5.50005M8 5.50005V7.5H16V5.50005M8 5.50005V5.20711C8 4.75435 8.17986 4.32014 8.5 4C8.82014 3.67986 9.25435 3.5 9.70711 3.5H14.2929C14.7456 3.5 15.1799 3.67986 15.5 4C15.8201 4.32014 16 4.75435 16 5.20711V5.50005M16 11.5H14M16 16.5H14M8 11.5L9 12.5L11 10.5M8 16.5L9 17.5L11 15.5"
        stroke={pathFill}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Icon.propTypes = {
  pathFill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Icon.defaultProps = {
  pathFill: "#FF8B22",
  width: "24",
  height: "25"
};

export default Icon;
